import React from 'react'
import SelectionStoreProvider, {
  useSelectionStore
} from 'context/SelectionStore/Manager/SelectionStoreProvider.manager'
import { useParams } from 'react-router'
import NewSeo from 'pages/Mobile/Selection/Manager/pages/NewSeo'
import { Switch } from 'react-router-dom'
import { SubPrivateRoute } from 'routes/PrivateRoute'
import { MANAGER } from 'constants/roles'
import {
  NEW_SEO,
  NEW_WL,
  SELECTION_STEP_PATH_LOADED
} from 'routes/constants.routes'
import CarFilter from 'pages/Mobile/Selection/Manager/pages/CarFilter'
import CarSelectionHeader from 'pages/Mobile/Selection/Manager/components/CarSelectionHeader/CarSelectionHeader'
import PageContainerMobile from 'components/PageContainer/layout/PageContainer.mobile'
import Demonstration from 'pages/Mobile/Selection/Manager/pages/Demonstration'
import CarSelection from 'pages/Mobile/Selection/Manager/pages/CarSelection'
import Paperwork from 'pages/Mobile/Selection/Manager/pages/Paperwork'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import NewWL from 'pages/Mobile/Selection/Manager/pages/NewWL'

const SelectionMnMobile = props => (
  <SelectionStoreProvider {...props}>
    <Selection />
  </SelectionStoreProvider>
)

export default SelectionMnMobile

const Selection = () => {
  const {
    store: { initLoad }
  } = useSelectionStore()
  const { step, id } = useParams()

  return initLoad ? (
    <LoaderBackdrop loading={initLoad} />
  ) : (
    <Switch>
      <SubPrivateRoute
        byRole={MANAGER}
        component={NewWL}
        path={SELECTION_STEP_PATH_LOADED(id)[NEW_WL]}
      />
      <SubPrivateRoute
        byRole={MANAGER}
        component={NewSeo}
        path={SELECTION_STEP_PATH_LOADED(id)[NEW_SEO]}
      />

      {step !== NEW_SEO && step !== NEW_WL && (
        <PageContainerMobile customHeader={<CarSelectionHeader />}>
          <Switch>
            <SubPrivateRoute
              byRole={MANAGER}
              component={CarFilter}
              path={SELECTION_STEP_PATH_LOADED(id)[0]}
            />{' '}
            <SubPrivateRoute
              byRole={MANAGER}
              component={Demonstration}
              path={SELECTION_STEP_PATH_LOADED(id)[1]}
            />{' '}
            <SubPrivateRoute
              byRole={MANAGER}
              component={CarSelection}
              path={SELECTION_STEP_PATH_LOADED(id)[2]}
            />{' '}
            <SubPrivateRoute
              byRole={MANAGER}
              component={Paperwork}
              path={SELECTION_STEP_PATH_LOADED(id)[3]}
            />
          </Switch>
        </PageContainerMobile>
      )}
    </Switch>
  )
}
